import React from 'react';
import styles from './PublishedCard.module.scss';
import InnerCard from './components/innerCard';
import OuterCard from './components/outerCard';
import UnderstoodButton
  from 'gui/components/editors/commons/editor/components/publishedCard/components/understoodButton';
import {IProduct} from 'data/interfaces/products';
import ShareButton from 'gui/pages/mainRouter/pages/ad/components/commons/shareButton/ShareButton';
import {PRODUCT_STATUS_PUBLISHED} from 'data/redux/constants/productsConstants';

export interface IPublishedCardProps {
  title?: string;
  children?: any;
  loading?: boolean;

  product?: Partial<IProduct>;
}

const PublishedCard = (props: IPublishedCardProps) => {
  return (<div className={styles.PublishedCard}>
      <OuterCard loading={props.loading} title="המודעה שלך התקבלה!" content={
        [
          'מודעתך עוברת לאישור הסופי של מערכת האתר',
          'ותפורסם ב-48 שעות הקרובות. ניתן לעקוב אחרי',
          'סטטוס המודעה באיזור האישי. המשך יום נפלא.'
        ]
      }>


        <InnerCard
          loading={props.loading}
          title="הצעדים הבאים"
          content={
            [
              <>
                <ShareButton
                  shareButtonClassName={styles.shareButton}
                  product={{...props.product, status: PRODUCT_STATUS_PUBLISHED}}
                  shareButtonText={"שתפו"}
                />
                את המודעה ברשתות החברתיות
              </>,
              'השלימו את המכירה',
              'הזמינו את החופשה הבאה במחיר פצצה 😊 יש באתר הצעות במחירים מדהימים ממוכרים נוספים בדיוק כמוכם'
            ]
          }
        >
          <UnderstoodButton loading={props.loading} product={props.product}/>
        </InnerCard>
      </OuterCard>
    </div>
  );
};

PublishedCard.defaultProps = {
  title: '',
  children: null,
  loading: false,
};

export default React.memo(PublishedCard);
